import { render, staticRenderFns } from "./settingyh.vue?vue&type=template&id=8d84b56c&"
import script from "./settingyh.vue?vue&type=script&lang=js&"
export * from "./settingyh.vue?vue&type=script&lang=js&"
import style0 from "./settingyh.vue?vue&type=style&index=0&id=8d84b56c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports